import React from 'react';

const servicesData = [
  { id: 1, title: "Subsea Cable Installation", desc: "Precision installation services for global connectivity.", img: "Services/1. Cable.png" },
  { id: 2, title: "Subsea Cable Repair", desc: "Rapid response maintenance and repair solutions.", img: "Services/2. Repair.png" },
  { id: 3, title: "Remote Operation Support", desc: "24/7 remote guidance and operational oversight.", img: "Services/3.1 Remote.jpg" },
  { id: 4, title: "TSS Cable Lay Software", desc: "Inhouse software subsea cable installation.", img: "Services/4. Data.jpg" },
  { id: 5, title: "USV Bathymetry Survey", desc: "Autonomous surveys using Unmanned Surface Vehicles.", img: "Services/5. Bathymetry.png" }
];

function ServicesParallax() {
  return (
    <div className="parallax-container-wrapper">
      <div className="parallax-scroll-area">
        {servicesData.map((item) => (
          <div className="para-card" key={item.id}>
            <div className="para-bg" style={{backgroundImage: `url('${process.env.PUBLIC_URL}/img/${item.img}')`}}></div>
            <div className="para-content">
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ServicesParallax;
